import { Marquee, variables, TextAnimation } from "politicamente-informados-ds";
import { FC } from "react";
import styled from "styled-components";



interface IChatMarquees {
    message?: string
}
const ChatMarquees: FC<IChatMarquees> = ({ message = 'POLITICMAENTE INFORMADOS' }) => {
    return (
        <WrapMarquees>
            <Marquee
                color={variables.colors.secondary50}
                backgroundColor={variables.colors.secondary50}
                duration={15}
                rotateDeg={0}
                direction={"left"}>
                <TextAnimation
                    repeatLines={1}
                    repeatContent={5}
                    className="marque-text fw-bold lh-1 text-uppercase font-outline-odd d-inline-block h2">
                    {message
                        .split("")
                        .map((l: string, i: number) => (
                            <span key={"word-" + i}>{l}</span>
                        ))}
                </TextAnimation>
            </Marquee>
            <Marquee
                color={variables.colors.secondary50}
                backgroundColor={variables.colors.secondary50}
                duration={15}
                rotateDeg={0}
                direction="right">
                <TextAnimation
                    repeatLines={1}
                    repeatContent={5}
                    className="marque-text fw-bold lh-1 text-uppercase font-outline-odd d-inline-block h2">
                    {message
                        .split("")
                        .map((l: string, i: number) => (
                            <span key={"word-" + i}>{l}</span>
                        ))}
                </TextAnimation>
            </Marquee>
        </WrapMarquees>
    );
}

export default ChatMarquees;



const WrapMarquees = styled.div`
  webkit-transform: translate(-50%, 50%) rotate(-5deg);
  transform: translate(-50%, 50%) rotate(-5deg);
`;
